import React from 'react';

const Loader = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="loader">
      <img 
        src="https://cdn.glitch.global/dbc455dd-1443-4546-992a-df355b63d16b/loader.png?v=1750283446482" 
        width="450px" 
        alt="Loading..." 
      />
    </div>
  );
};

export default Loader;